const initialState = {
  activeOnglet: "favoris",
  singleProgramId: null,
  openLots: [],
  openLotsData: {},
  openLotsLoading: {},
  openLotsError: {},
};

const enregistresReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ENREGISTRES_ACTIVE_ONGLET":
      return {
        ...state,
        activeOnglet: action.payload,
      };

    case "SET_ENREGISTRES_SINGLE_PROGRAM_ID":
      return {
        ...state,
        singleProgramId: action.payload,
      };

    case "ADD_ENREGISTRES_OPEN_LOT":
      if (state.openLots.includes(action.payload)) {
        return state;
      }
      return {
        ...state,
        openLots: [...state.openLots, action.payload],
      };

    case "REMOVE_ENREGISTRES_OPEN_LOT":
      return {
        ...state,
        openLots: state.openLots.filter((id) => id !== action.payload),
        openLotsData: {
          ...state.openLotsData,
          [action.payload]: undefined,
        },
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload]: undefined,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.payload]: undefined,
        },
      };

    case "FETCH_ENREGISTRES_SINGLE_LOT_REQUEST":
      return {
        ...state,
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload]: true,
        },
      };

    case "FETCH_ENREGISTRES_SINGLE_LOT_SUCCESS":
      return {
        ...state,
        openLotsData: {
          ...state.openLotsData,
          [action.payload.id]: action.payload,
        },
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.payload.id]: false,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.payload.id]: null,
        },
      };

    case "FETCH_ENREGISTRES_SINGLE_LOT_FAILURE":
      return {
        ...state,
        openLotsLoading: {
          ...state.openLotsLoading,
          [action.meta.documentId]: false,
        },
        openLotsError: {
          ...state.openLotsError,
          [action.meta.documentId]: action.payload,
        },
      };

    default:
      return state;
  }
};

export default enregistresReducer;
